<!-- Barra de ações -->
<div class="po-row po-mb-3 po-pt-4">
  <div class="po-sm-12 releases-action-bar">
    <po-button
      p-label="Nova Release"
      p-kind="primary"
      p-icon="po-icon-plus"
      (p-click)="openCreateModal()"
    ></po-button>

    <po-button
      p-label="Atualizar"
      p-kind="secondary"
      p-icon="po-icon-refresh"
      [p-loading]="loading"
      (p-click)="currentPage = 1; loadReleases()"
    ></po-button>
  </div>
</div>

<!-- Tabela de Releases -->
<po-table
  [p-columns]="releasesColumns"
  [p-items]="releases"
  [p-loading]="loading"
  [p-sort]="true"
  [p-actions]="releasesActions"
  [p-show-more-disabled]="!hasMoreReleases"
  [p-literals]="{ noData: 'Nenhuma release cadastrada.', showMore: 'Carregar mais' }"
  (p-show-more)="loadMoreReleases()"
></po-table>

<!-- ─────────────────────────────────────────────────────────────────────────
     Modal: Criar / Editar Release
───────────────────────────────────────────────────────────────────────────── -->
<po-modal
  #modalForm
  [p-title]="formMode === 'create' ? 'Nova Release' : 'Editar Release'"
  p-size="md"
  [p-primary-action]="modalFormPrimaryAction"
  [p-secondary-action]="modalFormSecondaryAction"
>
  <div class="po-row">
    <po-input
      class="po-sm-12"
      name="formName"
      p-label="Nome *"
      p-placeholder="Ex: v2025.Q3"
      p-max-length="100"
      [(ngModel)]="formName"
      [p-required]="true"
    ></po-input>
  </div>

  <div class="po-row">
    <po-textarea
      class="po-sm-12"
      name="formDescription"
      p-label="Descrição"
      p-placeholder="Descreva brevemente o objetivo desta release"
      p-rows="3"
      [(ngModel)]="formDescription"
    ></po-textarea>
  </div>

  <div class="po-row">
    <po-datepicker
      class="po-sm-12 po-md-6"
      name="formStartDate"
      p-label="Data de Início"
      p-format="dd/mm/yyyy"
      [(ngModel)]="formStartDate"
    ></po-datepicker>

    <po-datepicker
      class="po-sm-12 po-md-6"
      name="formEndDate"
      p-label="Data de Fim"
      p-format="dd/mm/yyyy"
      [(ngModel)]="formEndDate"
    ></po-datepicker>
  </div>

  <div class="po-row">
    <po-switch
      class="po-sm-12"
      name="formIsCurrent"
      p-label="Release Atual"
      p-label-on="Sim"
      p-label-off="Não"
      [(ngModel)]="formIsCurrent"
    ></po-switch>
  </div>
</po-modal>

<!-- ─────────────────────────────────────────────────────────────────────────
     Modal: Gerenciar Regras de uma Release
───────────────────────────────────────────────────────────────────────────── -->
<po-modal
  #modalRules
  [p-title]="'Regras da Release: ' + (managedRelease?.name ?? '')"
  p-size="xl"
  [p-primary-action]="modalRulesCloseAction"
>
  <!-- Loading inicial -->
  <div *ngIf="loadingRules" class="releases-rules-loading">
    <span class="po-icon po-icon-refresh releases-loading-icon"></span>
    <span>Carregando regras...</span>
  </div>

  <ng-container *ngIf="!loadingRules">
    <po-tabs>

      <!-- ── ABA: Regras Vinculadas ──────────────────────────────────────── -->
      <po-tab p-label="Regras Vinculadas" p-active="true">

        <ng-container *ngIf="linkedRules.length === 0">
          <po-info
            p-label="Nenhuma regra vinculada"
            p-value="Use a aba 'Catálogo' para adicionar regras a esta release."
          ></po-info>
        </ng-container>

        <ng-container *ngIf="linkedRules.length > 0">
          <!-- Cabeçalho da lista -->
          <div class="releases-rule-list-header">
            <span class="releases-rule-col-name">Regra</span>
            <span class="releases-rule-col-key">Chave</span>
            <span class="releases-rule-col-goal">Premissa</span>
            <span class="releases-rule-col-actions"></span>
          </div>

          <div
            *ngFor="let row of linkedRules"
            class="releases-rule-list-row"
          >
            <span class="releases-rule-col-name" [title]="row.rule_name">{{ row.rule_name }}</span>
            <span class="releases-rule-col-key"  [title]="row.rule_key">{{ row.rule_key }}</span>

            <div class="releases-rule-col-goal">
              <po-select
                [name]="'goal_' + row.rule_id"
                p-label=""
                [(ngModel)]="row.editingGoal"
                [p-options]="goalOptions"
              ></po-select>
            </div>

            <div class="releases-rule-col-actions">
              <po-button
                p-kind="secondary"
                p-icon="po-icon-ok"
                p-label="Salvar"
                p-size="small"
                (p-click)="updateLinkedRuleGoal(row)"
              ></po-button>
              <po-button
                p-kind="danger"
                p-icon="po-icon-delete"
                p-label="Remover"
                p-size="small"
                (p-click)="removeLinkedRule(row)"
              ></po-button>
            </div>
          </div>
        </ng-container>

      </po-tab>

      <!-- ── ABA: Catálogo de Regras ─────────────────────────────────────── -->
      <po-tab p-label="Catálogo">

        <!-- Filtro + ação -->
        <div class="po-row po-mb-2 po-mt-2">
          <po-input
            class="po-sm-12 po-md-7"
            name="catalogSearch"
            p-label="Buscar regra"
            p-placeholder="Nome ou chave da regra"
            [(ngModel)]="catalogSearch"
            (ngModelChange)="onCatalogSearchChange()"
          ></po-input>

          <div class="po-sm-12 po-md-5 releases-catalog-actions">
            <po-button
              p-label="Vincular Selecionadas"
              p-kind="primary"
              p-icon="po-icon-plus"
              [p-loading]="savingRules"
              [p-disabled]="selectedCatalogItems.length === 0"
              (p-click)="addSelectedRules()"
            ></po-button>

            <span *ngIf="selectedCatalogItems.length > 0" class="releases-catalog-counter">
              {{ selectedCatalogItems.length }} selecionada(s)
            </span>
          </div>
        </div>

        <!-- Estado vazio -->
        <ng-container *ngIf="catalogFiltered.length === 0">
          <po-info
            p-label="Nenhuma regra encontrada"
            p-value="Tente ajustar o filtro de busca."
          ></po-info>
        </ng-container>

        <!-- Cabeçalho do catálogo -->
        <ng-container *ngIf="catalogFiltered.length > 0">
          <div class="releases-catalog-header">
            <span class="releases-catalog-col-check">
              <po-checkbox
                name="checkAll"
                [(ngModel)]="allCatalogSelected"
              ></po-checkbox>
            </span>
            <span class="releases-catalog-col-name">Regra</span>
            <span class="releases-catalog-col-key">Chave</span>
            <span class="releases-catalog-col-goal">Premissa</span>
            <span class="releases-catalog-col-status">Status</span>
          </div>

          <!-- Itens do catálogo -->
          <div
            *ngFor="let item of catalogFiltered"
            class="releases-catalog-row"
            [class.releases-catalog-row--linked]="item.linked"
          >
            <span class="releases-catalog-col-check">
              <po-checkbox
                [name]="'check_' + item.rule.id"
                [(ngModel)]="item.selected"
                [p-disabled]="item.linked"
              ></po-checkbox>
            </span>

            <span class="releases-catalog-col-name" [title]="item.rule.name">{{ item.rule.name }}</span>
            <span class="releases-catalog-col-key"  [title]="item.rule.key">{{ item.rule.key }}</span>

            <div class="releases-catalog-col-goal">
              <po-select
                [name]="'pg_' + item.rule.id"
                p-label=""
                [(ngModel)]="item.pendingGoal"
                [p-options]="goalOptions"
                [p-disabled]="item.linked || !item.selected"
              ></po-select>
            </div>

            <span class="releases-catalog-col-status">
              <po-tag
                *ngIf="item.linked"
                p-value="Vinculada"
                p-color="color-11"
              ></po-tag>
            </span>
          </div>

          <!-- Carregar mais páginas do catálogo -->
          <div *ngIf="hasMoreCatalog" class="releases-catalog-load-more">
            <po-button
              p-label="Carregar mais regras"
              p-kind="secondary"
              p-icon="po-icon-arrow-down"
              (p-click)="loadMoreCatalog()"
            ></po-button>
          </div>
        </ng-container>

      </po-tab>

    </po-tabs>
  </ng-container>
</po-modal>
